<template>
  <div class="dropdown">
    <button
      class="dropbtn"
      style="border-radius: 0.5em;"
      @click="toggleDropdownContent">
      <i class="ui language icon"/>: {{ userLang.toUpperCase() }} <i class="triangle down icon"/>
    </button>
    <div
      :style="{ display: ( showDropdownContent ? 'block' : 'none' ) }"
      class="dropdown-content">
      <a @click="updateUserLang({ userLang: 'de' }); toggleDropdownContent();">DE</a>
      <a @click="updateUserLang({ userLang: 'fr' }); toggleDropdownContent();">FR</a>
      <a @click="updateUserLang({ userLang: 'it' }); toggleDropdownContent();">IT</a>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'LanguageToggle',
  data () {
    return {
      showDropdownContent: false
    }
  },
  computed: {
    ...mapState(['userLang'])
  },
  methods: {
    ...mapActions(['updateUserLang']),
    toggleDropdownContent () {
      this.showDropdownContent = !this.showDropdownContent
    }
  },
  mounted () {}
}
</script>

<style scoped>
  /* Style The Dropdown Button */
  .dropbtn {
    background-color: #6496BB !important;
    color: white;
    padding: 1em;
    min-height: 3em;
    max-height: 3em;
    font-size: 1em;
    border: none;
    cursor: pointer;
    position: relative;
    float: right;
  }

  .dropbtn:focus {
    outline: none;
  }
  /* The container <div> - needed to position the dropdown content */
  .dropdown {
    width: 100%;
    position: relative;
    display: inline-block;
  }

  /* Dropdown Content (Hidden by Default) */
  .dropdown-content {
    display: none;
    position: absolute;
    right: 0;
    top: 3em;
    background-color: #f9f9f9;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    z-index: 1;
  }

  /* Links inside the dropdown */
  .dropdown-content a {
    color: black;
    padding: 12px 16px;
    text-decoration: none;
    display: block;
  }

  /* Change color of dropdown links on hover */
  .dropdown-content a:hover {
    background-color: #f1f1f1
  }

  /* Change the background color of the dropdown button when the dropdown content is shown */
  .dropdown:hover .dropbtn {
    background-color: #3e8e41;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/LanguageToggle.vue